export default {
  crewTasks: [],
  crewTimesheetStatusMap: {
    2: "未申請", // 'UN_APPLIED',
    3: "申請中", // 'APPLYING',
    4: "承認済", // 'APPROVED',
    5: "差戻し", // 'REMAND',
    6: "作業予定", // 'SCHEDULED',
  },
};
